import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthContextProvider } from './context/AuthContext';
import SchoolIdProvider from './context/schoolIdContect/SchoolIdProvider'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SchoolIdProvider>
      <AuthContextProvider>
        <App />
      </AuthContextProvider>
    </SchoolIdProvider>
  </React.StrictMode>
);
reportWebVitals();
